<template>
    <span
        dusk="AddOnDraftPill"
        class="inline-flex h-[18px] items-center rounded-full border border-dashed border-theme-draft-border bg-theme-draft-bg px-1.5 text-[10px] font-semibold uppercase tracking-wider text-theme-draft"
    >
        {{ strings.draft }}
    </span>
</template>

<script>
'use strict';

import { mapState } from 'vuex';
import { addOnStrings } from './addOnStrings.js';

export default {
    name: 'AddOnDraftPill',
    computed: {
        ...mapState(['localizations', 'lang']),
        strings() {
            return addOnStrings(this.localizations, this.lang);
        },
    },
};
</script>
